import { log } from '@/log'
import { CartScopeService, CartScopeStateService } from '@/services/api/cart/scope'
import { MaybeFail, RedirectConfig } from '@spa/router/hooks/cart/scope/redirect-config'
import { NavigationGuard } from 'vue-router'

export const guardOnCrossBrandScopeBuilder = (scopeStateGateway: CartScopeStateService) =>
  (config: RedirectConfig<MaybeFail>): NavigationGuard =>
    async (to, _from, next): Promise<void> => {
      const scope = config.extractScope(to)
      if (scope.kind.isBrand) {
        log.error(`guard on cross brand scope can not accept brand scope. actual is ${ scope.toString() }`)

        return next(config.redirect.whenErrorOccurred)
      }

      scopeStateGateway.status(scope).then(result => result.fold(
        (error) => {
          log.error({ error })

          next(config.redirect.whenErrorOccurred)
        },
        (state) => {
          state.available ? next() : next(config.redirect.whenErrorOccurred)
        }
      ))
    }
export const guardOnCrossBrandScope = guardOnCrossBrandScopeBuilder(CartScopeService.create())
